/**
 * Cat Gatekeeper
 *
 * Declares a single web-accessible-resource entry (`assets/*`, `content.css`) matched
 * to http(s) origins with no `use_dynamic_url` — so its icons, animation clips and
 * stylesheet are all fetchable from any page at a fixed URL.
 *
 * The vendor-named `nekoicon` images are the cleanest signal: being images they load
 * through `probeImage` with no CORS grant, so they survive a restrictive page CSP.
 *
 * Manifest verified against version 1.1.10.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'elbikiflgfhjdjmficnigpeegjbhdidh';

export const catGatekeeper: ExtensionDefinition = {
  id: ID,
  name: 'Cat Gatekeeper',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Exposes assets and content.css to http(s) origins with no dynamic URL. The ' +
    'vendor-named nekoicon images are conclusive and load without a CORS grant.',
  signals: [
    {
      id: 'war-nekoicon-128',
      kind: 'web-accessible-resource',
      description:
        'Load assets/nekoicon128.png via <img>. A vendor-named icon exposed to every ' +
        'origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'assets/nekoicon128.png'),
    },
    {
      id: 'war-content-css',
      kind: 'web-accessible-resource',
      description: 'Fetch content.css — the injected stylesheet exposed as a static WAR.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content.css'),
    },
    {
      id: 'war-neko-webm',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/neko1.webm — one of the vendor-named cat animation clips, a ' +
        'third path independent of the icon and stylesheet.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/neko1.webm'),
    },
  ],
};
